import React from 'react'
import PropTypes from 'prop-types'
import {Eyebrow} from '@/components/ui/eyebrow'

const MinicartHeader = ({totalItems}) => {
    return (
        <div className="px-[0.9375rem] pt-[1.5625rem]">
            <Eyebrow
                size="small"
                className="text-emphasis"
                data-testid="minicartHeader-Eyebrow"
                type="text"
            >
                Your cart ({totalItems} Items)
            </Eyebrow>
        </div>
    )
}

MinicartHeader.propTypes = {
    totalItems: PropTypes.number.isRequired
}

export default MinicartHeader
